<template>
  <div class="skeleton-paragraph"></div>
</template>

<script>
export default {
  name: "Skeleton",

  props: {
    avator: {
      type: Boolean,
      default() {
        return false;
      }
    },

    active: {
      type: Boolean,
      default() {
        return false;
      }
    },

    round: {
      type: Boolean,
      default() {
        return false;
      }
    },

    paragraph: {
      type: Number,
      default() {
        return 1;
      }
    }
  }
};
</script>

<style>
@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>

<style lang="scss">
.skeleton-paragraph {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    hsla(0, 0%, 74.5%, 0.2) 25%,
    hsla(0, 0%, 50.6%, 0.24) 37%,
    hsla(0, 0%, 74.5%, 0.2) 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
}
</style>
